import React from 'react'
import { NavLink } from 'react-router-dom'
import './NavBar.css'

function NavBar() {




  const navStyles = {
    textDecoration: 'none',
    fontSize: '20px',

  };
 

  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <h3>LeeBakes</h3>
          <button className="navbar-toggler"  type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav navSide mb-2 mb-lg-0">


              <li className='nav-m ' >
                <NavLink class="nav-link" aria-current="page" to="/" style={navStyles}>Home</NavLink>
              </li>


              <li className='nav-m'>
                <NavLink class="nav-link " aria-current="page" to="/aboutme" style={navStyles}>About Me</NavLink>
              </li>

              <li className='nav-m'>
                <NavLink class="nav-link " aria-current="page" to="/gallery" style={navStyles}>Gallery</NavLink>
              </li>

             

              <li className='nav-m'>
                <NavLink class="nav-link " aria-current="page" to="/contactme" style={navStyles}>Contact Me</NavLink>
              </li>



            </ul>
          </div>
        </div>
      </nav>

    </div>
  )
  
}

export default NavBar